import { axios } from '~/clients';
import { getSpinnerData } from '~/constants/endpoints';
import { SpinnerData } from '~/contracts/vdp';

export default function fetchSpinnerData(
  stockNumber: number,
  controller: AbortController
): Promise<SpinnerData> {
  return axios(getSpinnerData(stockNumber), { signal: controller.signal }).then(
    r => r.data
  );
}
